export enum EventMaster {
  GOAL = 10,
  OWN_GOAL_FOR = 25,
  OWN_GOAL_AGAINST = 20,
  SUBSTITUTION = 19,
  INJURY_STOPPAGE = 40,
  STARTING_XI = 35,

  YELLOW_CARD = 27,
  RED_CARD = 22,
}

export enum EventMasterName {
  GOAL = 'goal',
  OWN_GOAL_FOR = 'own goal for',
  OWN_GOAL_AGAINST = 'own goal against',
  SUBSTITUTION = 'substitution',
  INJURY_STOPPAGE = 'injury stoppage',
  STARTING_XI = 'starting xi',
}
